import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `TipoInstalacion`, method: 'GET', body: null, token: token})
}
